import script from "./SalaryPaymentEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./SalaryPaymentEdit.vue?vue&type=script&setup=true&lang=js"

import "./SalaryPaymentEdit.vue?vue&type=style&index=0&id=72831e23&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72831e23"]])

export default __exports__